(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__premiaCardStars) return;
    window.__premiaCardStars = true;
    function go(e) {
      var s = e.target && e.target.closest && e.target.closest('.premia-cstars');
      if (!s) return;
      if (e.type === 'keydown' && e.key !== 'Enter') return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = s.getAttribute('data-href');
    }
    document.addEventListener('click', go, true);
    document.addEventListener('keydown', go, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
